import React from 'react'
import {Route, Switch} from 'react-router-dom';
import RouterPath from 'libs/RouterPath';
import StepperPages from './scenes/StepperPages';
import MyProcedureHome from './scenes/home/MyProcedureHome';

const rp = RouterPath.myProcedure;

function MyProcedure() {

    return (
        <Switch>
            {Object.values(rp.steps).map((x, i) => (
                <Route exact key={i} path={x} component={StepperPages}/>
            ))}
            <Route component={MyProcedureHome}/>
        </Switch>
    )
}

export default MyProcedure;

